import { Product } from '#pie/internal/api/pie-bff';

export const products: Record<Product, string> = {
  [Product.Both]: 'Beide',
  [Product.Electricity]: 'Electriciteit',
  [Product.Gas]: 'Gas',
  [Product.None]: 'Geen',
};
